import React, { useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from 'wmic-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { messages } from 'gw-capability-policychange-common-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import styles from './QuotePage.module.scss';
import metadata from './QuotePage.metadata.json5';

function QuotePage(props) {
    const { wizardData } = props;
    const { submissionVM } = wizardData;
    const { authenticated } = useAuthentication();
    const [allValuable, setAllValuable] = useState();
    const [allMortgagee, setAllMortgagee] = useState();
    const translator = useTranslator();

    const getDisplayName = (propertyInfos, type) => {
        const availableTypeLists = propertyInfos
            .flat()
            .filter((val) => val.availableTypeListValues)
            .find((availableType) => availableType.id === 'ArticleType');
        const availableTypeListValues = availableTypeLists.availableTypeListValues || [];
        return availableTypeListValues.find((list) => list.code === type).displayKey;
    };

    useEffect(() => {
        const setValuableNames = () => {
            const valuable = _.get(
                submissionVM.value,
                'lobData.homeowners.offerings[0].coverages.schedules',
                []
            );
            const scheduleItems = valuable.map((valuables) => valuables.scheduleItems);
            const propertyInfos = valuable.map((valuables) => valuables.propertyInfos);
            const displayNames = _.flatMap(scheduleItems).map((item) => {
                return !_.isUndefined(item.itemData.ArticleType)
                    ? getDisplayName(propertyInfos, item.itemData.ArticleType.typeCodeValue)
                    : _.get(item, 'itemData.SchedItemDescriptionId.stringValue', '-');
            });
            setAllValuable(displayNames.join(', '));
        };

        const setMortgageeNames = () => {
            const mortgagee = _.get(
                submissionVM.value,
                'lobData.homeowners.coverables.additionalInterests',
                []
            );
            const mortgageeNames = mortgagee.map(
                (mortgagees) => mortgagees.policyAdditionalInterest
            );
            const displayNames = mortgageeNames.map((mortgageeName) => mortgageeName.displayName);
            setAllMortgagee(displayNames.join(', '));
        };
        if (authenticated) {
            setValuableNames();
            setMortgageeNames();
        }
    }, [authenticated, submissionVM]);

    const resolvers = {
        resolveClassNameMap: styles
    };
    const overrideProps = {
        valuables: {
            value: allValuable
        },
        mortgagee: {
            value: allMortgagee
        },
        hoEffectiveDateRangeId: {
            value: {
                endDate: _.get(submissionVM, 'baseData.periodEndDate.value'),
                startDate: _.get(submissionVM, 'baseData.periodStartDate.value')
            }
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
        },
        [overrideProps, submissionVM]
    );

    return (
        <WizardPage
            cancelLabel={translator(appConfig.persona === 'policyholder' ? messages.cancelAllChanges : messages.cancel)}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                resolveValue={readValue}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

QuotePage.propTypes = wizardProps;
export default QuotePage;
